import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";
import { toast } from "react-toastify";

export const useOfflinePayment = (token) => {
    const offlinePayment = async (payload) => {
        return await axios.post(`${Config.ApiUrl}/tenant/pay/offline`, payload, {
            headers: {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const { mutate: processOfflinePayment, isLoading: isOfflinePaymentLoading } = useMutation(offlinePayment, {
        onSuccess: (response) => {
            // toast.success(response?.data?.msg || "Offline payment request submitted successfully!");
            return response;
        },
        onError: (error) => {
            const errorMessage = error?.response?.data?.msg || "Failed to process offline payment";
            toast.error(errorMessage);
        },
    });

    return {
        processOfflinePayment,
        isOfflinePaymentLoading,
    };
};